import {
  CustomScriptContextConsumer,
  SpaceAccessControl
} from '@eggplant/context'
import {
  Icons,
  NavItemVerticalMini
} from '@eggplant/pattern-library'
import {
  CUSTOM_SCRIPT,
  GIT_CONNECTIONS,
  TEST_MANAGEMENT_TOOLS,
  WEBHOOK,
  renderLinkTo,
  routeLabels
} from '@eggplant/routing'
import { FaGitAlt } from 'react-icons/fa'

interface Props {
  base: string
  isCollapsed: boolean
}

const SystemNav = ({
  base,
  isCollapsed
}: Props) =>
  <>
    <NavItemVerticalMini
      icon={<Icons.TestToolsBold aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[TEST_MANAGEMENT_TOOLS]}
    >
      {renderLinkTo(base + '/' + TEST_MANAGEMENT_TOOLS)}
    </NavItemVerticalMini>
    <NavItemVerticalMini
      icon={<FaGitAlt aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[GIT_CONNECTIONS]}
    >
      {renderLinkTo(base + '/' + GIT_CONNECTIONS)}
    </NavItemVerticalMini>
    <NavItemVerticalMini
      icon={<Icons.Webhook aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[WEBHOOK]}
    >
      {renderLinkTo(base + '/' + WEBHOOK)}
    </NavItemVerticalMini>
    <SpaceAccessControl
      allowedRoles={['dai:admin']}
      isHiddenIfDenied
    >
      <CustomScriptContextConsumer>
        {
          ({ isCustomScriptEnabled }) =>
            isCustomScriptEnabled && (
              <NavItemVerticalMini
                icon={<Icons.CustomScript />}
                isCollapsed={isCollapsed}
                label={routeLabels[CUSTOM_SCRIPT]}
              >
                {renderLinkTo(base + '/' + CUSTOM_SCRIPT)}
              </NavItemVerticalMini>
            )
        }
      </CustomScriptContextConsumer>
    </SpaceAccessControl>
  </>

export default SystemNav
